import {debounce} from "../functions";

document.addEventListener('DOMContentLoaded', function (e) {

    const ptServices = e.target.querySelector('.pt__services')

    if (ptServices) {
        const serviceFeeds = ptServices.querySelectorAll('.feed-service')
        const serviceSelect = ptServices.querySelector('.js-service-select');
        const serviceSearch = ptServices.querySelector('.js-service-search');

        function applyFilters() {
            serviceFeeds.forEach((e) => {
                let display = [];
                if (serviceSelect.value !== '') {
                    display.push(e.dataset.parentId === serviceSelect.value)
                } else {
                    display.push(true)
                }

                if (serviceSearch.value === '') {
                    display.push(true)
                } else {
                    display.push(e.textContent.toString().toLowerCase().includes(serviceSearch.value.toString().toLowerCase()))
                }

                e.style.display = display.filter((e) => e === true).length === 2 ? 'flex' : 'none'
            })
        }

        if (serviceSelect && serviceSearch) {
            serviceSelect.addEventListener('change', applyFilters)
            serviceSearch.addEventListener('input', debounce(applyFilters, 250))
        }
    }
})
